import { all } from 'redux-saga/effects';

import geraSenha from './geraSenha/saga';

export default all([geraSenha]);
